module.exports = __webpack_public_path__ + "img/ner_yes.171c87ae.png";